import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown, faUser } from "@fortawesome/pro-solid-svg-icons"
import { Link } from "@reach/router"
import { useTranslation } from "react-i18next"

import { useUserContext } from "../../../context/UserContext"
import { useAuthenticationContext } from "../../../context/AuthenticationContext"
import DropDownButton from "../../DropDownButton/DropDownButton"

import Styles from "./User.module.css"

type UserProps = {}
const User: React.FC<UserProps> = () => {
	const { logout } = useAuthenticationContext()
	const { user } = useUserContext()
	const [t] = useTranslation("shared.account")

	return (
		<>
			<div className={Styles.user}>
				<div className="relative">
					<DropDownButton
						buttonProps={{
							children: (
								<div className="flex">
									<div className={Styles.avatar}>
										<FontAwesomeIcon
											className={Styles.avatarImage}
											icon={faUser}
										/>
									</div>
									<span
										className={Styles.name}
									>{`${user.first_name} ${user.last_name}`}</span>
									<span className="m-auto ml-4">
										<FontAwesomeIcon icon={faChevronDown} />
									</span>
								</div>
							),
						}}
						dropdownProps={{
							className: Styles.dropdown,
						}}
					>
						<div className={Styles.dropdownContent}>
							<Link
								className={Styles.dropdownItem}
								to="/account/profile"
							>
								{t("dropdown.myAccount", "My Account")}
							</Link>
							<Link
								className={Styles.dropdownItem}
								to="/account/password"
							>
								{t(
									"dropdown.changePassword",
									"Change Password"
								)}
							</Link>
							<button
								className={Styles.dropdownItem}
								onClick={logout}
							>
								{t("dropdown.logout", "Logout")}
							</button>
						</div>
					</DropDownButton>
				</div>
			</div>
		</>
	)
}

export default User
